module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADnSURBVEiJ7ZMhDsJAEEWf6AGQlQiC6kEQHKACgUDgSsKRkJW79+AICASKIKgv5jedbLelBduXjPn7Z2Yzswszf7IACsABN6BW3KQV8kwmAc7AyxTti5e8yZTipSnggB2wMp6VNGd85dgmFyU8gM0I/1beWrmD7GR8A9mY24hMObVqREnMTfbB2RrwQKXw0iwH5d7pGVUuwzVS/El3uc9Ik6vO8liDZrHHQPfSPZAqrGY50S68Q/POl4FeSU+NlkqrAu+S9p9EiX2aKQ36agzSjMPRjqh5/+GIfmLKkv9q8u2ZzszM9PAB2sVaCXbSlxsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/View_alt.png
// module id = rihD
// module chunks = 8